const {
    CAROUSEL_FOR_LESS_THAN_SEVEN_TAB,
    CAROUSEL_FOR_MORE_THAN_SEVEN_TAB,
    CAROUSEL_FOR_SINGLE_TAB,
} = require('../raConstants/index');

const getCarouselTabPerClick = options => {
    if (options && options.length === CAROUSEL_FOR_SINGLE_TAB) {
        return CAROUSEL_FOR_SINGLE_TAB;
    }

    if (options && options.length < CAROUSEL_FOR_MORE_THAN_SEVEN_TAB) {
        return CAROUSEL_FOR_LESS_THAN_SEVEN_TAB;
    }

    if (options && options.length >= CAROUSEL_FOR_MORE_THAN_SEVEN_TAB) {
        return CAROUSEL_FOR_MORE_THAN_SEVEN_TAB;
    }
};

module.exports = {
    getCarouselTabPerClick,
};
